import _ from 'lodash'

import { getAllBots, getBotFlows } from 'Selectors/bots'

export const getBotById = (state, botId) => {
  const allBots = getAllBots(state)
  return _.find(allBots, { id: botId }) || {}
}

export const getDefaultFlowId = (state, botId) => {
  const bot = getBotById(state, botId)
  if (bot?.default_flow_id) {
    return bot.default_flow_id
  }
  const flows = getBotFlows(state, botId)
  return flows?.[0]?.id
}
